<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="items"
      hide-default-footer
      fixed-header
      :no-data-text="$t('common.nodata')"
      class="custom-price-data-table gray10"
      :header-props="{ 'sort-icon': '$sortIcon' }"
    >
      <template v-slot:item.index="{ item }">
        {{ items.indexOf(item) + (pageNo - 1) * pageSize + 1 }}
      </template>
      <template v-slot:item.time="{ item }">
        {{ item.time | dateTimeFilter }}
      </template>
      <template v-slot:item.direction="{ item }">
        {{
          item.direction == "BUY" ? $t("openOrders.buy") : $t("openOrders.sell")
        }}
      </template>
      <template v-slot:item.type="{ item }">
        <!-- {{
          item.direction == "BUY" ? $t("openOrders.buy") : $t("openOrders.sell")
        }} -->
        <span v-if="item.type === 'LIMIT_PRICE'">{{
          $t("openOrders.limit")
        }}</span>
        <span v-if="item.type === 'MARKET_PRICE'">{{
          $t("openOrders.market")
        }}</span>
      </template>
      <template v-slot:item.operation="{ item }">
        <v-btn
          :loading="detailsBtnLoading == item.orderId"
          color="primaryX"
          text
          @click="getDetails(item)"
          >{{ $t("openOrders.details") }}</v-btn
        >
        <v-btn
          color="error"
          text
          class="ms-2"
          @click="() => cancelOrder(item.orderId)"
          >{{ $t("openOrders.undo") }}</v-btn
        >
      </template>
    </v-data-table>
    <!--    detail modal-->
    <v-dialog v-model="isOrderDetailModalOpen" width="500">
      <v-card>
        <v-card-title>
          {{ $t("openOrders.orderDetails") }}
        </v-card-title>
        <v-card-text>
          <div class="font-Regular-14 custom-modal-body pb-5">
            <ul
              v-if="Object.entries(order).length > 0"
              class="preconditionDetailList"
            >
              <li class="d-flex justify-space-between mb-5">
                <span class="font-Regular-12 precondition-detail-title">
                  {{ $t("openOrders.time") }}</span
                >
                <span class="font-Regular-12">{{
                  order.createdDate | dateTimeFilter
                }}</span>
              </li>

              <li class="d-flex justify-space-between mb-5">
                <span class="font-Regular-12 precondition-detail-title">
                  {{ $t("openOrders.type") }}</span
                >
                <span class="font-Regular-12">
                  <template v-if="order.source === 'OCO_ORDER'">
                    {{ $t("openOrders.ocoLimit") }}
                  </template>

                  <template v-else-if="order.source === 'MANUAL_ORDER'">
                    {{ $t("openOrders.limit") }}
                  </template>
                </span>
              </li>
              <li class="d-flex justify-space-between mb-5">
                <span class="font-Regular-12 precondition-detail-title">{{
                  $t("openOrders.pairCoin")
                }}</span>
                <span class="font-Regular-12">{{ order.symbol }}</span>
              </li>
              <li class="d-flex justify-space-between mb-5">
                <span class="font-Regular-12 precondition-detail-title">{{
                  $t("openOrders.price")
                }}</span>
                <span class="font-Regular-12">{{ order.orderPrice }}</span>
              </li>
              <li class="d-flex justify-space-between mb-5">
                <span class="font-Regular-12 precondition-detail-title">{{
                  $t("openOrders.amount")
                }}</span>
                <span class="font-Regular-12">
                  {{ order.amount }}
                  {{ order.symbol.toUpperCase().split("/")[0] }}
                </span>
              </li>
              <li class="d-flex justify-space-between mb-5">
                <span class="font-Regular-12 precondition-detail-title">{{
                  $t("openOrders.turnOver")
                }}</span>
                <span class="font-Regular-12">
                  {{ order.turnOver }}
                  {{ order.symbol.toUpperCase().split("/")[1] }}
                </span>
              </li>
            </ul>

            <div class="table-responsive-wrapper">
              <v-data-table
                :headers="orderDetailColumns"
                :items="orderDetailsData"
                hide-default-footer
                fixed-header
                class="custom-price-data-table gray10"
                :no-data-text="$t('common.nodata')"
              ></v-data-table>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!--    cancel modal-->
    <v-dialog v-model="cancelOrderModal" width="500">
      <v-card>
        <v-card-title>
          {{ $t("openOrders.cancelOrder") }}
        </v-card-title>
        <v-card-text>
          {{ $t("openOrders.cancelOrderDescription") }}
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" text @click="cancel">
            {{ $t("openOrders.confirm") }}
          </v-btn>
          <v-btn color="primary" text @click="cancelOrderModal = false">
            {{ $t("openOrders.cancel") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { ExchangeService } from "@/services";
import dayjs from "dayjs";

export default {
  data() {
    return {
      headers: [
        { text: "#", value: "index", width: "50px", align: "center" },
        {
          text: this.$t("openOrders.time"),
          value: "time",
          sortable: true,
          align: "center"
        },
        {
          text: this.$t("openOrders.pairCoin"),
          value: "symbol",
          sortable: false,
          align: "center"
        },
        {
          text: this.$t("openOrders.orderType"),
          value: "type",
          sortable: false,
          align: "center"
        },
        {
          text: this.$t("openOrders.tradeDirection"),
          value: "direction",
          sortable: false,
          align: "center"
        },
        {
          text: this.$t("openOrders.price"),
          value: "price",
          sortable: true,
          align: "center"
        },
        {
          text: this.$t("openOrders.amount"),
          value: "amount",
          sortable: true,
          align: "center"
        },
        {
          text: this.$t("openOrders.tradedAmount"),
          value: "tradedAmount",
          sortable: true,
          align: "center"
        },
        {
          text: this.$t("openOrders.tradedPercent"),
          value: "tradedPercent",
          sortable: false,
          align: "center"
        },
        {
          text: this.$t("openOrders.averageTradePrice"),
          value: "averagePrice",
          sortable: true,
          align: "center"
        },
        {
          text: this.$t("openOrders.turnOver"),
          value: "turnover",
          sortable: true,
          align: "center"
        },
        {
          text: this.$t("openOrders.refCode"),
          value: "trackingCode",
          sortable: false,
          align: "center"
        },
        {
          text: this.$t("openOrders.operation"),
          value: "operation",
          sortable: false,
          align: "center"
        }
      ],
      orderDetailColumns: [
        {
          text: this.$t("openOrders.amount"),
          value: "amount",
          width: "180",
          align: "center"
        },
        {
          text: this.$t("openOrders.price"),
          value: "price",
          width: "180",
          align: "center"
        },
        {
          text: this.$t("openOrders.time"),
          value: "time",
          width: "180",
          align: "center"
        },
        {
          text: this.$t("openOrders.turnOver"),
          value: "turnOver",
          width: "180",
          align: "center"
        }
      ],
      cancelOrderModal: false,
      isOrderDetailModalOpen: false,
      detailsBtnLoading: null,
      orderDetailsData: [],
      order: {},
      cancelOrderId: ""
    };
  },
  props: ["items", "pageNo", "pageSize"],
  filters: {
    dateTimeFilter(date) {
      return (
        dayjs(date).format("HH:mm") + " - " + dayjs(date).format("YYYY/MM/DD")
      );
    }
  },
  methods: {
    cancelOrder(orderId) {
      if (this.detailsBtnLoading !== null) return;
      this.cancelOrderModal = true;
      this.cancelOrderId = orderId;
    },
    getDetails(data) {
      if (this.detailsBtnLoading !== null) return;
      if (data.source === "MANUAL_ORDER" || data.source === "OCO_ORDER") {
        this.getOrderDetails(data.orderId);
      } else if (
        data.source === "STOP_LIMIT_ORDER" ||
        data.source === "OCO_STOP_LIMIT_ORDER"
      ) {
        this.getStopLimitOrderDetail(data.orderId);
      }
    },
    getOrderDetails(orderId) {
      this.detailsBtnLoading = orderId;
      ExchangeService.getOrderDetails(orderId)
        .then(response => {
          this.orderDetailsData = response.data.data.detail;
          this.order = response.data.data.order;
          this.isOrderDetailModalOpen = true;
        })
        .finally(() => {
          this.detailsBtnLoading = null;
        });
    },
    getStopLimitOrderDetail(orderId) {
      this.detailsBtnLoading = orderId;
      ExchangeService.preconditionDetailsByOrderId({ id: orderId })
        .then(response => {
          this.orderStopLimitDetailsData = response.data.data;
          this.isOrderStopLimitModalOpen = true;
        })
        .finally(() => {
          this.detailsBtnLoading = null;
        });
    },
    cancel() {
      this.$emit("cancelCreatedOrder", this.cancelOrderId);
      this.cancelOrderId = "";
      this.cancelOrderModal = false;
    }
  }
};
</script>

<style lang="scss" scoped></style>
